import { AutoComplete } from "antd";
import { useCallback, useEffect, useState } from "react";
import { api } from "../../config";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../interfaces/users";
import { toast } from "react-toastify";
import { formatTaxId } from "./SingleTicketModal";
import { redirect } from "react-router-dom";

export const NewSearchBar = () => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const [selectedTicketId, setSelectedTicketId] = useState<number | undefined>(
    undefined
  );
  const [lastTimeout, setLastTimeout] = useState<any | undefined>(undefined);
  const [ticketField, setTicketField] = useState("");
  const [ticketLoading, setTicketLoading] = useState(false);
  const [tickets, setTickets] = useState<any[]>();
  const [typing, setTyping] = useState(false);
  const fetchTickets = useCallback(async () => {
    if (ticketField.length < 4) return;
    try {
      setTicketLoading(true);
      const resultTickets = await api(token).get(
        `tickets/search/${ticketField}`
      );
      setTickets(resultTickets);
    } catch (error) {
      toast.error("Ocorreu um erro");
    } finally {
      setTicketLoading(false);
    }
  }, [ticketField, token]);

  const onChangeInput = (string: string) => {
    if (lastTimeout) clearTimeout(lastTimeout);
    setTicketLoading(true);
    setTyping(true);
    const timeout = setTimeout(() => setTyping(false), 800);
    setLastTimeout(timeout);
    setTicketField(string);
  };
  useEffect(() => {
    if (typing) {
      return;
    } else {
      fetchTickets();
    }
  }, [fetchTickets, typing]);
  return (
    <div className="flex flex-col gap-8 w-[400px]">
      <div className="relative">
        {ticketLoading && (
          <p className="absolute top-0 right-2 z-50">Carregando...</p>
        )}
        <AutoComplete
          //@ts-ignore
          value={ticketField}
          onChange={(e) => onChangeInput(e)}
          onSelect={(e) => {
            const ticket = JSON.parse(e);
            window.location.replace(`/montagem?id=${ticket.id}`);
            setTicketField(ticket.title);
          }}
          allowClear
          options={
            tickets?.map?.((ticket: any) => ({
              label: `${ticket.title} --- Venda: ${ticket.saleId} --- ID Simpl.: ${ticket.id} --- Assist. Tec.: ${ticket.idAssistTec}`,
              value: JSON.stringify(ticket),
            })) ?? []
          }
          size="large"
          style={{ width: "100%" }}
          optionRender={(props) => {
            const splitted = String(props.label)?.split?.("---");

            return (
              <div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {splitted[0]}
                </div>
                <div>{splitted[1]}</div>
                <div>{splitted[2]}</div>
                {!!splitted[3].replace(/\D+/, '') && <div className="bg-yellow-300 rounded-full w-fit px-4 font-bold shadow">{splitted[3]}</div>}
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};
